import axios from '../../axios/index.js'

export default{
    changeInvoiceHold(data){
        return axios.post('changeInvoiceHold',data)      
    }
}